<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 5C3 4 4 3 5 3H19C20 3 21 4 21 5V15C21 16 20 17 19 17H9L6 20V17H5C4 17 3 16 3 15V5Z"
        stroke="#000" stroke-width="1.5" stroke-linejoin="round"/>
</svg>
